module.exports = __webpack_public_path__ + "static/media/JPEG5.4e11cf39.jpg";